import * as React from "react";
import { PlanMetricRows, IPinnedRowsRenderersComponentProps } from "../pinned-row-constants";
import { TotalRow } from "./total-row";
import { PlanRow } from "./plan-row";
import { DiffRow } from "./diff-row";

export interface IPlanMetricDoorRendererProps extends IPinnedRowsRenderersComponentProps {
    planRowType: PlanMetricRows;
    reviewPlan: any;
    dimensionFilters: string[][];
}

export const PlanMetricDoorColumn: React.FunctionComponent<IPlanMetricDoorRendererProps> = (props) => {
    const { total, plan } = props;

    switch (props.planRowType) {
        case PlanMetricRows.Total:
            return <TotalRow {...props} total={total} />;
        case PlanMetricRows.Plan:
            return <PlanRow {...props} plan={plan} />;
        case PlanMetricRows.Diff:
            return <DiffRow {...props} total={total} plan={plan} />;
        default:
            return <div />;
    }
};
